<template>
  <div class="hd-SearchField">
    <form
      ref="form"
      :action="path"
      method="get"
      class="hd-SearchField_Form hd-Searchfield_VueForm position-relative"
    >
      <vue-autosuggest
        :suggestions="suggestions"
        v-model="currentValue"
        :input-props="{
          class: 'form-control hd-SearchField_InputField',
          id: 'autosuggest__input',
          name: 'keywords',
          placeholder: placeholder,
        }"
        :getSuggestionValue="getSuggestionValue"
        @input="onInputChange"
        @selected="selectHandler"
        :component-attr-id-autosuggest="id"
        class="hd-SearchField_Form hd-Searchfield_VueForm w-100"
      >
        <template slot-scope="{ suggestion }">
          <img :src="suggestion.item.images[0].url" class="rounded hd-SearchField_ResultImage" />
          <span>{{ getSuggestionValue(suggestion) }}</span>
        </template>
      </vue-autosuggest>
      <button class="btn hd-SearchField_SearchBtn" type="submit">
        <SearchIcon class="svg-24 svg-fill-dark" />
      </button>
    </form>
  </div>
</template>

<script>
import { VueAutosuggest } from "vue-autosuggest";
import { mapGetters, mapActions } from "vuex";
import SearchIcon from "../../icons/atalanda/search.svg";
import debounce from "lodash/debounce";

export default {
  name: "Searchbar",
  components: {
    VueAutosuggest,
    SearchIcon,
  },
  props: {
    path: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    initialValue: {
      type: String,
      default: "",
      required: false,
    },
    id: {
      type: String,
      required: false,
      default: "searchbar",
    },
    city: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      currentValue: this.initialValue,
    };
  },
  computed: {
    ...mapGetters({
      searchResults: "productSearch/getSearchResults",
      currentLocale: "getCurrentLocale",
    }),
    suggestions() {
      return [{ data: this.searchResults.slice(0, 10) }];
    },
  },
  methods: {
    ...mapActions({ fetchSearchResults: "productSearch/fetchSearchResults" }),
    onInputChange(value) {
      this.fetchResults(value);
    },
    fetchResults: debounce(function(value) {
      let searchQuery = value.trim();
      this.fetchSearchResults({ keywords: searchQuery, city: this.city });
    }, 500),
    selectHandler(suggestionItem) {
      if (suggestionItem?.item) {
        window.location.assign(`${this.path}/${suggestionItem.item.permalink}`);
      } else {
        this.$refs.form.submit();
      }
    },
    getSuggestionValue(suggestion) {
      return suggestion.item.name[this.currentLocale] || suggestion.item.name.de;
    },
  },
};
</script>

<style lang="scss">
@import "~styles/global";

.hd-SearchField_InputField.autosuggest__input--open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.autosuggest__results-container {
  position: absolute;
  z-index: $zi-high;
  top: 100%;
  left: 0;
  width: 100%;
  background: $white;
  box-shadow: $box-shadow-xl;
  border-bottom-left-radius: $border-radius;
  border-bottom-right-radius: $border-radius;
}

.autosuggest__results-item--highlighted {
  background-color: $gray-200;
}

.autosuggest__results ul {
  padding-left: 0;
  margin-bottom: 0;
}

.autosuggest__results-item {
  list-style-type: none;
  padding: $spacer / 4 $spacer / 2;
  font-size: $font-size-sm;
  cursor: pointer;
  border-radius: $border-radius;
  margin: $spacer / 6;
}

.hd-SearchField_ResultImage {
  width: $autocomplete-product-image-size;
  height: $autocomplete-product-image-size;
  object-fit: contain;
}
</style>
